// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"eA","text":"eB"};